// src/api/payload.ts
import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_PAYLOAD_API || 'https://manage.jakdmedia.com/api';

export const getFunnelById = async (id: string) => {
  const res = await axios.get(`${API_BASE_URL}/funnels/${id}?depth=2`);
  return res.data;
};
